<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name {{ keyName }}
      span.validation-label(v-if="required == true") 必須

    .register-value
      .d-flex.justify-content-center
        input.register-form.datetime.mr-1(v-model="_value" :name="name" type="text" :placeholder="placeholder"
          v-validate="validationRules" :data-vv-as="(validationKeyName) ? validationKeyName : keyName" @click="showModal"
          :disabled="disabled"  :class="[ { noinput: (required == true && !_value) }, { disable: disabled } ]" readonly)
        b-button.clear-btn(@click="ondelete")
          span クリア

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br

  DatetimePickerModal(v-model="show" :date.sync="_date" :time.sync="_time" :minutes-step="minutesStep" @ok="inputDatetime")
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import DatetimePickerModal from "@/pc/basics/DatetimePickerModal.vue";

/**
 * カレンダー入力コンポーネント
 *
 * - カレンダーでの日付入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component({
  components: {
    DatetimePickerModal
  }
})
export default class FormDatetimePicker extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: number;

  /** 日付 */
  @Prop({ required: true })
  date!: string;

  /** 時刻 */
  @Prop({ required: true })
  time!: string;
  /** 時間の上昇値 */
  @Prop({ default: () => 5 })
  minutesStep!: number;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** input要素のプレースホルダー */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  placeholder!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  styles!: any;

  @Prop({ default: false })
  disabled!: boolean;

  show: boolean = false;

  public showModal(): void {
    this.show = true;
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    if (this.value) {
      return this.$dateUtil.convertNumberToString(this.value, "yyyy年mm月dd日 hh:MM");
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    return;
  }

  public inputDatetime(): void {
    const date: string = this.$dateUtil.replaceNonNumeric(this.date); // date format is yyyy-mm-dd
    const time: string = this.$dateUtil.replaceNonNumeric(this.time); // time format is hh:MM:ss
    this.$emit("input", Number(`${date}${time}000`));

    return;
  }

  get _date(): string {
    return this.date;
  }

  set _date(newValue: string) {
    this.$emit("update:date", newValue);
    return;
  }

  get _time(): string {
    return this.time;
  }

  set _time(newValue: string) {
    this.$emit("update:time", newValue);
    return;
  }

  public ondelete(): void {
    this.$emit("input", null);
    this.$emit("update:date", "");
    this.$emit("update:time", "");
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.register-form {
  min-width: 210px !important;
  width: 210px !important;
}
.disable {
  cursor: not-allowed;
  background-color: $btn-disable !important;
  color: $btn-font-disable !important;
  transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
}
</style>
